const SLASH = '/';
const PATH_USER = 'user';
const PATH_SIGNIN = 'signin';
const PATH_ASSETS = 'assets';
const PATH_ICONS = 'icons';
const PATH_ROLES = 'roles/pageaction/marketplace/v1';
const TOKEN = 'token';
const AVA = 'ava';
const PLATFORM = 'platform';


// login authentication

const ROUTE_USER_LOGIN = `${SLASH}${PATH_USER}${SLASH}${PATH_SIGNIN}`;
const ROUTE_ASSETS_ICON = `${PATH_ICONS}${SLASH}`;
const ROUTE_ASSETS_IMAGES = `${SLASH}`;
const ROUTE_USER_ROLES = `${SLASH}${PATH_USER}${SLASH}${PATH_ROLES}`;
const ROUTE_APP_TOKEN = `${SLASH}${AVA}${SLASH}${PLATFORM}${SLASH}${TOKEN}`;
const ROUTE_ASSET_LIB_COMPS = `${SLASH}${PATH_ASSETS}`;

export {
    ROUTE_USER_LOGIN,
    ROUTE_ASSETS_ICON,
    ROUTE_ASSETS_IMAGES,
    ROUTE_USER_ROLES,
    ROUTE_APP_TOKEN,
    ROUTE_ASSET_LIB_COMPS
};
